export {
  default as poolToys,
  ReactComponent as PoolToys,
} from '@assets/icons/features-and-amenities/pool-toys.svg'    
